import templates from './templates.json'

export const ro = {
    ...templates}
